<template>
  <div class="guarantor-new">
    <Row :gutter="16">
      <i-col span="16" offset="4">
        <Form ref="newForm"
          :model="step2"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <div class="padding-top-20"></div><div class="padding-top-20"></div>
          <FormItem label="所在行业" prop="industryId" style="width:100%">
            <Select v-model="step2.industryId" filterable placeholder="选择专属行业/领域">
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <div class="padding-top-20"></div><div class="padding-top-20"></div>
          <Row :gutter="16">
            <Col span="3"><Button type="warning" size="large" style="display:inline" @click="backward">上一步</Button></Col>
            <Col span="21"><Button type="primary" size="large" style="display:inline" long @click="submit">下一步</Button></Col>
          </Row>
        </Form>
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      step2: {
        industryId: null,
      },
      modelValidate: {
        industryId: [
          { required: true, type: 'number', message: '请选择行业/领域', trigger: 'blur' }
        ]
      },
      industries: [],
      industryRecords: []
    }
  },
  watch: {
  },
  mounted () {
    this.initIndustrySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    backward () {
      this.$emit('go-backward')
    },
    initIndustrySelect () {
      Api.Guarantor.getMyPermittedIndustries(this.data.cityId).then((res) => {
        let data = res.map((c) => {
          return {
            id: c.industryId,
            value: c.industryId,
            label: c.industryName
          }
        })
        this.industryRecords = res
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          let ind = this.industryRecords.filter((i) => {
            return i.industryId === this.step2.industryId
          })
          this.$emit('finish-step2', ind[0])
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  .student-avatar {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
  }
}
</style>
